<template>
  <RevInfoBlock
    v-if="shouldDisplay"
    :content="i18n(translations.content)"
    :icon="IconWarning"
    :title="i18n(translations.title)"
    variant="danger"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type {
  CartResponse,
  Deliver,
} from '@backmarket/nuxt-layer-checkout/api/cart/types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import { isCountryShippable } from '~/scopes/checkout/utils/isCountryShippable'

import translations from './UnavailableCountry.translations'

const props = defineProps<{
  country: Deliver['country']
  shippableCountries: CartResponse['shippableCountries']
}>()

const i18n = useI18n()

const shouldDisplay = computed(() => {
  return !isCountryShippable(props.country, props.shippableCountries)
})
</script>
